







































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class ExpirationInput extends Vue {
  @Prop({ default: '' }) private month!: string
  @Prop({ default: '' }) private year!: string
  @Prop({ default: '' }) private monthError!: string
  @Prop({ default: '' }) private yearError!: string
  @Prop({ default: '' }) private expireError!: string
  @Prop({ default: false }) private readonly!: boolean

  private onMonthInput(e: Event) {
    const target = e.target as HTMLInputElement
    this.$emit('update:month', target ? target.value : '')
  }

  private onYearInput(e: Event) {
    const target = e.target as HTMLInputElement
    this.$emit('update:year', target ? target.value : '')
  }
}
